import { Stack, Button } from "@mui/material";
import React from "react";
import { buttonColors } from "../../utility/types/constant";
import { useDispatch } from "react-redux";
import { logOut } from "../../redux/actions/userActions";
import { AppDispatch } from "../../redux/store/store";
import { useNavigate } from "react-router-dom";

const SignOut = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const handleLogOut = async () => {
    try {
      await dispatch(logOut()).unwrap(); // Ensure logout completes

      localStorage.setItem("recentlyLoggedOut", "true"); // Set flag

      localStorage.clear();

      sessionStorage.clear();

      navigate("/circle/sign-in"); // Navigate after logout
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <Stack>
      <Button
        variant="contained"
        size="small"
        onClick={handleLogOut}
        sx={{
          mx: 1,
          backgroundColor: buttonColors.persianRed,
          fontSize: "1em",
          "&:hover": {
            backgroundColor: buttonColors.persianRed,
          },
          mt: 1,
          mb: 1,
        }}
      >
        Sign Out
      </Button>
    </Stack>
  );
};

export default SignOut;
